import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import Select from "react-select";
import DateRange2 from "../../Component/DateRange/DateRange2";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { Toast } from "../../Component/Toast";
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";
import SubmitButton from "../../Component/SubmitButton";

const Report = () => {
  const { kv, set } = useStoreKv();
  const REPORT_SCROLL_KEY = "reportScrollPosition";
  const getTodayDate = () => {
  const today = new Date();

  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
  const DEFAULT_LOT_OPTIONS = [
    { value: "Dear", label: "Dear" },
    { value: "Kerala", label: "Kerala" },
  ];

  const DEFAULT_TIME_OPTIONS_DEAR = [
    { value: "1 PM", label: "1 PM", game_id: null },
    { value: "6 PM", label: "6 PM", game_id: null },
    { value: "8 PM", label: "8 PM", game_id: null },
  ];

  const DEFAULT_TIME_OPTIONS_KERALA = [
    { value: "3 PM", label: "3 PM", game_id: null },
  ];

  const navigate = useNavigate();
  const [lotDraw, setLotDraw] = useState("");
  const [timeDraw, setTimeDraw] = useState(null);
  const [errors, setErrors] = useState({});
  const [drawDate, setDrawDate] =  useState(getTodayDate());
  const [timeOptions, setTimeOptions] = useState([]);
  // const [lotOptions, setLotOptions] = useState([]);
  const [lotOptions, setLotOptions] = useState(
    kv.lotOptions || DEFAULT_LOT_OPTIONS,
  );
  const [selectedTimeId, setSelectedTimeId] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedCostId, setSelectedCostId] = useState(null);
  const [salesDate, setSalesDate] =  useState(getTodayDate());
  const [costDate, setCostDate] =  useState(getTodayDate());
  const [clientDate, setClientDate] =  useState(getTodayDate());
  // const [salesLotOptions, setSalesLotOptions] = useState([]);
  const [salesLotOptions, setSalesLotOptions] = useState(
    kv.lotOptions || DEFAULT_LOT_OPTIONS,
  );
  const [salesTimeOptions, setSalesTimeOptions] = useState([]);
  const [costLotOptions, setCostLotOptions] = useState(
    kv.lotOptions || DEFAULT_LOT_OPTIONS,
  );
  // const [costLotOptions, setCostLotOptions] = useState([]);
  const [costTimeOptions, setCostTimeOptions] = useState([]);
  const [clientLotOptions, setClientLotOptions] = useState(
    kv.lotOptions || DEFAULT_LOT_OPTIONS,
  );
  // const [clientLotOptions, setClientLotOptions] = useState([]);
  const [clientTimeOptions, setClientTimeOptions] = useState([]);
  const [salesLot, setSalesLot] = useState(null);
  const [salesTime, setSalesTime] = useState(null);
  const [costLot, setCostLot] = useState(null);
  const [costTime, setCostTime] = useState(null);
  const [clientLot, setClientLot] = useState(null);
  const [clientTime, setClientTime] = useState(null);

  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [loading6, setLoading6] = useState(false);

  const [salesSLotId, setSalesSlotId] = useState(null);
  const [clientSLotId, setClientSlotId] = useState(null);
  const [selectedLotData, setSelectedLotData] = useState([]);
  const [selectedSalesLotData, setSelectedSalesLotData] = useState([]);
  const [selectedCostLotData, setSelectedCostLotData] = useState([]);
  const [selectedClientLotData, setSelectedClientLotData] = useState([]);
  const [drawDataStatus, setDrawDataStatus] = useState(true);

  const [gameId, setGameId] = useState(null);

  const [mobile, setMobile] = useState("");

  const [salesDisable, setSalesDisable] = useState(true);
  const [drawDisable, setDrawDisable] = useState(true);
  const [costDisable, setCostDisable] = useState(true);
  const [clientDisable, setClientDisable] = useState(true);

  const location = useLocation();
  const navigationType = useNavigationType();
  const scrollRef = useRef(null);

  //  const scrollRef = useRef(null);
  

  useEffect(() => {
    const checkDateChange = () => {
      const today = getTodayDate();

      if (drawDate !== today) setDrawDate(today);
      if (salesDate !== today) setSalesDate(today);
      if (costDate !== today) setCostDate(today);
      if (clientDate !== today) setClientDate(today);
    };

    checkDateChange();

    const interval = setInterval(checkDateChange, 60000); // every 1 min

    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const savedPosition = sessionStorage.getItem(REPORT_SCROLL_KEY);

    //     console.log("Navigation Type:", navigationType, "Saved Position:", savedPosition);

    if (scrollRef.current) {
      if (navigationType === "POP" && savedPosition) {
        // Restore position on back/forward navigation
        setTimeout(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollTop = Number(savedPosition);
          }
        }, 0);
      } else {
        // Scroll to top on fresh entry (PUSH or REPLACE)
        setTimeout(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
          }
          // Also clear the saved position for next time if it wasn't a POP
          sessionStorage.setItem(REPORT_SCROLL_KEY, 0);
        }, 0);
      }
    }
  }, [location, navigationType]);

  useEffect(() => {
    const content = scrollRef.current;
    if (content) {
      content.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (content) {
        content.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const handleScroll = () => {
    const position = scrollRef.current ? scrollRef.current.scrollTop : 0;
    sessionStorage.setItem(REPORT_SCROLL_KEY, position);
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem("isReload", "true");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (!lotDraw) {
      setTimeOptions(
        lotDraw?.value === "Kerala"
          ? DEFAULT_TIME_OPTIONS_KERALA
          : DEFAULT_TIME_OPTIONS_DEAR,
      );
    }
    if (!salesLot) {
      setSalesTimeOptions(
        salesLot?.value === "Kerala"
          ? DEFAULT_TIME_OPTIONS_KERALA
          : DEFAULT_TIME_OPTIONS_DEAR,
      );
    }
    if (!costLot) {
      setCostTimeOptions(
        costLot?.value === "Kerala"
          ? DEFAULT_TIME_OPTIONS_KERALA
          : DEFAULT_TIME_OPTIONS_DEAR,
      );
    }
    if (!clientLot) {
      setClientTimeOptions(
        clientLot?.value === "Kerala"
          ? DEFAULT_TIME_OPTIONS_KERALA
          : DEFAULT_TIME_OPTIONS_DEAR,
      );
    }
  }, [lotDraw, salesLot, costLot, clientLot]);

  const getList = async () => {
    setDrawDisable(false);
    if (!drawDate) return;

    try {
      setLoading(true);

      const res = await get(`${URLS.REPORTDRAW}?date=${drawDate}`);

      if (res?.status === "success" && res?.data.length !== 0) {
        const data = res.data;
        setSelectedLotData(data);

        let formatted = [];

        // If any Dear_* exists
        if (data.some((i) => i.name.toLowerCase().startsWith("dear"))) {
          formatted.push({ value: "Dear", label: "Dear" });
        }

        // If any Kerala exists
        if (data.some((i) => i.name.toLowerCase() === "kerala")) {
          formatted.push({ value: "Kerala", label: "Kerala" });
        }

        setLotOptions(formatted);
        set("lotOptions", formatted);
        setDrawDisable(true);
        // Auto-select if only one option
        // if (formatted.length === 1) setLotDraw(formatted[0].value);
      } else {
        setLotOptions(DEFAULT_LOT_OPTIONS);
        setDrawDisable(true);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!drawDate) return;
    if (!lotDraw) {
      setTimeOptions([]);
      return;
    }

    const fetchTimes = async () => {
      try {
        if (!selectedLotData || selectedLotData.length === 0) {
          setTimeOptions(
            lotDraw?.value === "Kerala"
              ? DEFAULT_TIME_OPTIONS_KERALA
              : DEFAULT_TIME_OPTIONS_DEAR,
          );
          return;
        }

        const lowerLot = lotDraw.value?.toLowerCase();
        const filtered = selectedLotData
          .filter((item) => {
            const name = item.name.toLowerCase();

            if (lowerLot === "dear") return name.startsWith("dear");
            if (lowerLot === "kerala") return name.includes("kerala");
            return false;
          })
          .map((item) => ({
            value: item.lot_time,
            label: item.lot_time,
            id: item.id,
            game_id: item.game_id,
          }));

        if (filtered.length > 0) {
          setTimeOptions(filtered);
          set("lotTimeOptions", filtered);
        }
        //         console.log("Filtered Time Options:", filtered);
      } catch (err) {
        console.error(err);
      }
    };

    fetchTimes();
  }, [lotDraw, drawDate, selectedLotData]);

  useEffect(() => {
    getList();
  }, [drawDate]);

  const getSalesList = async () => {
    setSalesDisable(false);
    if (!salesDate) return;
    const status = [1, 2, 3, 4, 5];
    const queryString = status.map((s) => `status[]=${s}`).join("&");
    try {
      const res = await get(
        `${URLS.OTHERREPORT}?date=${salesDate}&${queryString}`,
      );

      if (res?.status === "success" && res?.data.length !== 0) {
        const data = res.data;
        setSelectedSalesLotData(data);
        let formatted = [];

        // If any Dear_* exists
        if (data.some((i) => i.name.toLowerCase().startsWith("dear"))) {
          formatted.push({ value: "Dear", label: "Dear" });
        }

        // If any Kerala exists
        if (data.some((i) => i.name.toLowerCase() === "kerala")) {
          formatted.push({ value: "Kerala", label: "Kerala" });
        }

        setSalesLotOptions(formatted);
        setSalesDisable(true);
      } else {
        setSalesLotOptions(DEFAULT_LOT_OPTIONS);
        setSalesDisable(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getSalesList();
  }, [salesDate]);

  useEffect(() => {
    if (!salesDate) return;
    if (!salesLot) {
      setSalesTimeOptions([]);
      return;
    }

    const fetchSalesTimes = async () => {
      //       console.log("selectedSalesLotData", selectedSalesLotData);

      try {
        if (!salesLot || selectedSalesLotData.length === 0) {
          setSalesTimeOptions(
            salesLot?.value === "Kerala"
              ? DEFAULT_TIME_OPTIONS_KERALA
              : DEFAULT_TIME_OPTIONS_DEAR,
          );
          //           console.log("lgggchecks");

          return;
        }

        const lowerLot = salesLot.value.toLowerCase();
        //         console.log("salesLot", salesLot);

        const filtered = selectedSalesLotData
          .filter((item) => {
            const name = item.name.toLowerCase();
            if (lowerLot === "dear") return name.startsWith("dear");
            if (lowerLot === "kerala") return name.includes("kerala");
            return false;
          })
          .map((item) => ({
            value: item.lot_time,
            label: item.lot_time,
            game_id: item.game_id,
            id: item.id,
          }));
        //         console.log("filtered sales", filtered);

        if (filtered.length > 0) {
          setSalesTimeOptions(filtered);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchSalesTimes();
  }, [salesLot, salesDate]);

  useEffect(() => {
    setSalesLot(null);
    setSalesTime(null);
    setSalesSlotId(null);
    setSelectedSalesLotData([]);
  }, [salesDate]);

  useEffect(() => {
    setLotDraw(null);
    setTimeDraw(null);
    setSelectedId(null);
    setSelectedLotData([]);
  }, [drawDate]);

  useEffect(() => {
    setCostLot(null);
    setCostTime(null);
    setSelectedCostId(null);
    setSelectedCostLotData([]);
  }, [costDate]);

  useEffect(() => {
    setClientLot(null);
    setClientTime(null);
    setClientSlotId(null);
    setSelectedClientLotData([]);
  }, [clientDate]);

  useEffect(() => {
    const getCostList = async () => {
      setCostDisable(false);
      if (!costDate) return;
      const status = [1, 2, 3, 4, 5];
      const queryString = status.map((s) => `status[]=${s}`).join("&");
      try {
        const res = await get(
          `${URLS.OTHERREPORT}?date=${costDate}&${queryString}`,
        );

        if (res?.status === "success" && res?.data.length !== 0) {
          const data = res.data;
          setSelectedCostLotData(data);
          let formatted = [];

          // If any Dear_* exists
          if (data.some((i) => i.name.toLowerCase().startsWith("dear"))) {
            formatted.push({ value: "Dear", label: "Dear" });
          }

          // If any Kerala exists
          if (data.some((i) => i.name.toLowerCase() === "kerala")) {
            formatted.push({ value: "Kerala", label: "Kerala" });
          }

          setCostLotOptions(formatted);
          setCostDisable(true);
        } else {
          setCostLotOptions(DEFAULT_LOT_OPTIONS);
          setCostDisable(true);
        }
      } catch (err) {
        console.error(err);
      }
    };

    getCostList();
  }, [costDate]);

  useEffect(() => {
    if (!costDate) return;
    if (!costLot) {
      setCostTimeOptions([]);
      return;
    }

    const fetchCostTimes = async () => {
      if (!costLot || selectedCostLotData.length === 0) {
        setCostTimeOptions(
          costLot?.value === "Kerala"
            ? DEFAULT_TIME_OPTIONS_KERALA
            : DEFAULT_TIME_OPTIONS_DEAR,
        );
        return;
      }
      try {
        const lowerLot = costLot.value.toLowerCase();

        const filtered = selectedCostLotData
          .filter((item) => {
            const name = item.name.toLowerCase();
            if (lowerLot === "dear") return name.startsWith("dear");
            if (lowerLot === "kerala") return name.includes("kerala");

            return false;
          })
          .map((item) => ({
            value: item.lot_time,
            label: item.lot_time,
            id: item.id,
          }));

        setCostTimeOptions(filtered);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCostTimes();
  }, [costLot, costDate]);

  useEffect(() => {
    const getClientList = async () => {
      setClientDisable(false);
      if (!clientDate) return;
      const status = [1, 2, 3, 4, 5];
      const queryString = status.map((s) => `status[]=${s}`).join("&");
      try {
        const res = await get(
          `${URLS.OTHERREPORT}?date=${clientDate}&${queryString}`,
        );

        if (res?.status === "success" && res?.data.length !== 0) {
          const data = res.data;
          setSelectedClientLotData(data);
          let formatted = [];

          // If any Dear_* exists
          if (data.some((i) => i.name.toLowerCase().startsWith("dear"))) {
            formatted.push({ value: "Dear", label: "Dear" });
          }

          // If any Kerala exists
          if (data.some((i) => i.name.toLowerCase() === "kerala")) {
            formatted.push({ value: "Kerala", label: "Kerala" });
          }

          setClientLotOptions(formatted);
          setClientDisable(true);
        } else {
          setClientLotOptions(DEFAULT_LOT_OPTIONS);
          setClientDisable(true);
        }
      } catch (err) {
        console.error(err);
      }
    };

    getClientList();
  }, [clientDate]);

  useEffect(() => {
    if (!clientDate) return;
    if (!clientLot) {
      setClientTimeOptions([]);
      return;
    }

    const fetchClientTimes = async () => {
      if (!clientLot || selectedClientLotData.length === 0) {
        setClientTimeOptions(
          clientLot?.value === "Kerala"
            ? DEFAULT_TIME_OPTIONS_KERALA
            : DEFAULT_TIME_OPTIONS_DEAR,
        );
        return;
      }
      try {
        const lowerLot = clientLot.value.toLowerCase();

        const filtered = selectedClientLotData
          .filter((item) => {
            const name = item.name.toLowerCase();
            if (lowerLot === "dear") return name.startsWith("dear");
            if (lowerLot === "kerala") return name.includes("kerala");

            return false;
          })
          .map((item) => ({
            value: item.lot_time,
            label: item.lot_time,
            id: item.id,
          }));

        setClientTimeOptions(filtered);
      } catch (err) {
        console.error(err);
      }
    };

    fetchClientTimes();
  }, [clientLot, clientDate]);

  const handleSalesReport = async (idLoad, isNumber) => {
    //     console.log("selectedSalesLotData", selectedSalesLotData, gameId);

    const postId = selectedSalesLotData.find(
      (item) => item.game_id === gameId,
    )?.id;

    const id = idLoad || postId;

    // if (!salesLot || !salesTime) {
    //   return;
    // }

    // if (selectedSalesLotData.length == 0) return;

    if (isNumber) {
      if (!salesLot || !salesTime) return;
    }

    let idData = [];

    if (isNumber) {
      idData = [id];
    } else {
      if (id) {
        idData = [id];
      } else {
        if (!salesLot) {
          idData = selectedSalesLotData.map((item) => item.id);
        } else {
          const lowerLot = salesLot.value.toLowerCase();

          idData = selectedSalesLotData
            .filter((item) => {
              const name = item.name.toLowerCase();
              if (lowerLot === "dear") return name.startsWith("dear");
              if (lowerLot === "kerala") return name.includes("kerala");
              return false;
            })
            .map((item) => item.id);
        }
      }
    }

    //     console.log("Sending slot ids:", idData);

    if (selectedSalesLotData.length === 0) {
      Toast("No Record Found!");
      return;
    }

    const queryString = idData.map((s) => `game_slot_id[]=${s}`).join("&");
    const numberId = `game_slot_id=${id}`;

    isNumber ? setLoading2(true) : setLoading1(true);

    const reportName = isNumber ? "game/number-wise" : "sale";

    const ID = isNumber ? numberId : queryString;

    const res = await get(`${URLS.SALESREPORT}/${reportName}?${ID}`);

    setLoading1(false);
    setLoading2(false);

    if (res?.status === "success") {
      navigate(isNumber ? "/number-wise" : "/sales", {
        state: {
          listData: res,
          slotId: idData,
          reportName: reportName,
          ID: ID,
          lot_name: salesLot?.value,
          time: salesTime?.value,
          date: salesDate,
        },
      });
    } else {
      Toast("No data found");
    }
  };

  const handleClientReport = async (idLoad, isWinning) => {
    const postId = selectedClientLotData.find(
      (item) => item.game_id === gameId,
    )?.id;

    const id = idLoad || postId;

    // if (!clientLot || !clientTime) {
    //   return;
    // } else if (!id) {
    //   Toast('No Record Found!');
    //   return;
    // }

    let idData = [];

    if (id) {
      idData = [id];
    } else {
      if (!clientLot) {
        idData = selectedClientLotData.map((item) => item.id);
      } else {
        const lowerLot = clientLot.value.toLowerCase();

        idData = selectedClientLotData
          .filter((item) => {
            const name = item.name.toLowerCase();
            if (lowerLot === "dear") return name.startsWith("dear");
            if (lowerLot === "kerala") return name.includes("kerala");
            return false;
          })
          .map((item) => item.id);
      }
    }

    //     console.log("Sending slot ids:", idData);

    if (selectedClientLotData.length === 0) {
      Toast("No Record Found!");
      return;
    }

    if (isWinning) {
      setLoading6(true);
    } else {
      setLoading5(true);
    }

    const queryString = idData.map((s) => `game_slot_id[]=${s}`).join("&");
    const resportName = isWinning ? "client/winning" : "client/purches";
    const res = await get(
      `${URLS.SALESREPORT}/${resportName}?${queryString}&mobile=${mobile}`,
    );
    //     console.log("res client resport", res);

    if (res?.status === "success") {
      if (isWinning) {
        setLoading6(false);
      } else {
        setLoading5(false);
      }
      if (isWinning) {
        if (res?.status === "success") {
          navigate("/winning-report", {
            state: {
              listData: res,
              slotId: queryString,
              mobile: mobile,
              resportName: resportName,
              lot_name: clientLot?.value,
              time: clientTime?.value,
              date: clientDate,
            },
          });
        } else {
          Toast("No data found for the selected slot");
        }
      } else {
        if (res?.status === "success") {
          navigate("/purchase-report", {
            state: {
              listData: res,
              slotId: queryString,
              mobile: mobile,
              resportName: resportName,
              lot_name: clientLot?.value,
              time: clientTime?.value,
              date: clientDate,
            },
          });
        } else {
          Toast("No data found for the selected slot");
        }
      }
    }

    setLoading6(false);
    setLoading5(false);
  };

  const handleDrawReport = async (idLoad) => {
    const postId = selectedLotData.find((item) => item.game_id === gameId)?.id;

    const id = idLoad || postId;

    if (!lotDraw || !timeDraw) {
      return;
    } else if (!id) {
      Toast("No Record Found!");
      return;
    }

    try {
      setLoading3(true);
      const res = await get(`${URLS.DRAWREPORT}?game_slot_id=${id}`);
      //       console.log("Fetched data:", res);

      if (res?.status === "success") {
        const hasDeclare = res?.result_declared;
        navigate(`/draw-report`, {
          state: {
            listData: res,
            slotId: id,
            lot_name: lotDraw?.value,
            time: timeDraw?.value,
            date: drawDate,
            hasDeclare: hasDeclare,
          },
        });
      } else {
        Toast(res?.message || "No data found for the selected slot");
      }
      setLoading3(false);
    } catch (err) {
      console.error(err);
      setLoading3(false);
    } finally {
      setLoading3(false);
    }
  };

  const handleCostReport = async (idLoad) => {
    const postId = selectedCostLotData.find(
      (item) => item.game_id === gameId,
    )?.id;

    const id = idLoad || postId;

    if (!costLot || !costTime) {
      return;
    } else if (!id) {
      Toast("No Record Found!");
      return;
    }

    try {
      setLoading4(true);
      const res = await get(
        `${URLS.SALESREPORT}/game/overall-cost?game_slot_id=${id}`,
      );
      //       console.log("Fetched data:", res);

      if (res?.status === "success") {
        Toast(res?.message || "No data found for the selected slot");
      }

      if (res?.status === "success") {
        navigate(`/cost-report`, {
          state: {
            listData: res,
            slotId: id,
            lot_name: costLot?.value,
            time: costTime?.value,
            date: costDate,
          },
        });
      }
      setLoading4(false);
    } catch (err) {
      console.error(err);
      setLoading4(false);
    } finally {
      setLoading4(false);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: 8,
      border: "1px solid #8F0D3dCC",
      border: `1px solid ${state.isFocused || state.hasValue ? "#8F0D3d" : "#8F0D3dCC"}`,
      boxShadow: state.isFocused ? "transparent" : "0 0 0 1px #dffffd66",
      "&:hover": {
        border: "1px solid #8F0D3dCC",
      },
      backgroundColor: "#F0EDE6",
      minHeight: 51,
      padding: "3px 10px",
      fontFamily: state.isSelected ? "f3" : "f2",
      color: "#8F0D3d",
    }),

    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      backgroundColor: "#F0EDE6",
      borderRadius: 8,
    }),

    menuList: (provided) => ({
      ...provided,
      backgroundColor: "#F0EDE6",
      borderRadius: 8,
    }),

    option: (provided, state) => ({
      ...provided,
      fontFamily: "f2",
      backgroundColor: state.isSelected
        ? "transparent"
        : state.isFocused
          ? "transparent"
          : "transparent",
      color: state.isSelected ? "#8F0D3d" : "#8F0D3d",
      cursor: "pointer",
      ":active": {
        backgroundColor: "#8F0D3d33",
      },
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#8F0D3d",
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#8F0D3d",
      "&:hover": {
        color: "#8F0D3d",
      },
    }),
  };

  return (
    <div className="dashRightView">
      <CustomScroll ref={scrollRef}>
        <div
          style={{ paddingBottom: 80 }}
          className="container_overalls col-md-5 "
        >
          <div className="my-2 f4 fs-xs-17" style={{
            marginBottom: "16px",
          }}>SALES REPORT</div>
          <div className="announcement_date mb-3 col-md-5">
            <DateRange2
              selectedDate={salesDate}
              setSelectedDate={setSalesDate}
            />
          </div>
          <div className=" my-3 pb-2 col-md-5">
            <div className="d-flex ac-js">
              <label className={`form-label f3 fs-md-14 fs-lg-16 m-0 ${!salesDisable ? "gray" : "primary1"}`}>
                Lot Name
              </label>
            </div>
            <Select
              noOptionsMessage={() => ""}
              className="location-search"
              options={salesLotOptions}
              value={salesLot}
              onChange={(selected) => {
                setSalesLot(selected);
                setSalesTime(null);
                setSalesSlotId(null);
              }}
              placeholder="Select Lot"
              isDisabled={!salesDate || !salesDisable}
              styles={customStyles}
              isSearchable={false}
            />
          </div>
          <div className=" my-3 pb-2 col-md-5">
            <div className="d-flex ac-js col-md-5">
              {/* <label
                className={`form-label f3 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  ${!salesDisable ? "gray" : "primary"}`}
              >
                Time
              </label> */}
              <label className={`form-label f3 fs-md-14 fs-lg-16 m-0 ${!salesDisable ? "gray" : "primary1"}`}>
                Time
              </label>
            </div>
            <Select
              noOptionsMessage={() => ""}
              className="location-search"
              onChange={(selected) => {
                setSalesTime(selected);
                setSalesSlotId(selected.id);
                setGameId(selected.game_id);
              }}
              options={salesTimeOptions}
              value={salesTime}
              placeholder="Select Time"
              isDisabled={!salesLot?.value || !salesDisable}
              styles={customStyles}
              isSearchable={false}
            />
          </div>
          <div style={{ textAlign: "center" }} className=" my-3 col-md-5">
            {/* <button
              disabled={loading1}
              onClick={() => handleSalesReport(salesSLotId, false)}
              className="add-button f3 w-100 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white"
            >
              {loading1 ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white", padding: 8 }}
                  ></span>
                </>
              ) : (
                <span style={{ top: -1.5, position: "relative" }}>
                  Get Sales Report
                </span>
              )}
            </button> */}

            <SubmitButton
              disabled={loading1}
              onClick={() => handleSalesReport(salesSLotId, false)}
              loading={loading1}
              title="Get Sales Report"

            />
          </div>
          <div style={{ textAlign: "center" }} className=" my-3 col-md-5">
            {/* <button
              disabled={!salesLot || !salesTime || loading1 || loading2}
              onClick={() => handleSalesReport(salesSLotId, true)}
              className="add-button f3 w-100 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white"
            >
              {loading2 ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white", padding: 8 }}
                  ></span>
                </>
              ) : (
                <span style={{ top: -1.5, position: "relative" }}>
                  Number Wise Report
                </span>
              )}
            </button> */}
            <SubmitButton
              disabled={!salesLot || !salesTime || loading1 || loading2}
              onClick={() => handleSalesReport(salesSLotId, true)}
              loading={loading2}
              title="Number Wise Report"

            />
          </div>
          <div className="my-2 f4 fs-xs-17" style={{
            marginTop: "40px",
            marginBottom: "16px",
          }} >DRAW REPORT</div>
          <div className="announcement_date mb-3 col-md-5">
            <DateRange2 selectedDate={drawDate} setSelectedDate={setDrawDate} />
          </div>
          <div className=" my-3 pb-2 col-md-5">
            <div className="d-flex ac-js">
              <label
                className={`form-label m-0 f3 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  ${!drawDisable ? "gray" : "primary1"}`}
              >
                Lot Name
              </label>
            </div>
            <Select
              noOptionsMessage={() => ""}
              className="location-search"
              options={lotOptions}
              value={lotDraw}
              onChange={(selected) => {
                setLotDraw(selected);
                setTimeDraw(null);
                setSelectedTimeId(null);
                setSelectedId(null);
              }}
              placeholder="Select Lot"
              isDisabled={!drawDate || !drawDisable}
              styles={customStyles}
              isSearchable={false}
            />
          </div>
          <div className=" my-3 pb-2 col-md-5 col-md-5">
            <div className="d-flex ac-js">
              <label
                className={`form-label m-0 f3 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  ${!drawDisable ? "gray" : "primary1"}`}
              >
                Time
              </label>
            </div>
            <Select
              noOptionsMessage={() => ""}
              className="location-search"
              onChange={(selected) => {
                setTimeDraw(selected);
                setSelectedTimeId(selected.id);
                setSelectedId(selected?.game_id);
                setGameId(selected.game_id);
              }}
              options={timeOptions}
              isDisabled={!lotDraw?.value || !drawDisable}
              value={timeDraw}
              placeholder="Select Time"
              styles={customStyles}
              isSearchable={false}
            />
          </div>
          <div style={{ textAlign: "center" }} className=" my-3 col-md-5">
            {/* <button
              disabled={!lotDraw || !timeDraw || loading3 || !drawDataStatus}
              onClick={() => handleDrawReport(selectedTimeId)}
              className={`add-button f3 w-100 fs-xs-15  fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 white ${!lotDraw || !timeDraw ? "button-disabled" : ""
                }`}
            >
              {loading3 ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white", padding: 8 }}
                  ></span>
                </>
              ) : (
                <span style={{ top: -1.5, position: "relative" }}>
                  Get Winning Report
                </span>
              )}
            </button> */}
            <SubmitButton
              disabled={!lotDraw || !timeDraw || loading3 || !drawDataStatus}
              onClick={() => handleDrawReport(selectedTimeId)}
              loading={loading3}
              title="Get Winning Report"

            />

            {!drawDataStatus && (
              // <button
              //   className={`add-button f3 w-100 fs-xs-15 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17`}
              //   style={{ marginTop: 15, background: "white", color: "black" }}
              // >
              //   On Processing...
              // </button>
              <SubmitButton
                title="On Processing..."

                style={{ marginTop: 15 }}
                disabled={true}
              />
            )}
          </div>
          <span className="my-2 f4 fs-xs-17">COST REPORT</span>
          <div className="announcement_date mb-3 col-md-5">
            <DateRange2 selectedDate={costDate} setSelectedDate={setCostDate} />
          </div>
          <div className=" my-3 pb-2 col-md-5">
            <div className="d-flex ac-js ">
              <label
                className={`form-label m-0 f3 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  ${!costDisable ? "gray" : "primary1"}`}
              >
                Lot Name
              </label>
            </div>
            <Select
              noOptionsMessage={() => ""}
              className="location-search"
              options={costLotOptions}
              value={costLot}
              onChange={(selected) => {
                setCostLot(selected);
                setCostTime(null);
                setSelectedCostId(null);
              }}
              isDisabled={!costDate || !costDisable}
              placeholder="Select Lot"
              styles={customStyles}
              isSearchable={false}
            />
          </div>
          <div className=" my-3 pb-2 col-md-5">
            <div className="d-flex ac-js">
              <label
                className={`form-label m-0 f3 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  ${!costDisable ? "gray" : "primary1"}`}
              >
                Time
              </label>
            </div>
            <Select
              noOptionsMessage={() => ""}
              className="location-search"
              onChange={(selected) => {
                setCostTime(selected);
                setSelectedCostId(selected.id);
                setGameId(selected.game_id);
              }}
              options={costTimeOptions}
              value={costTime}
              placeholder="Select Time"
              isDisabled={!costLot?.value || !costDisable}
              styles={customStyles}
              isSearchable={false}
            />
          </div>
          <div style={{ textAlign: "center" }} className=" my-3 col-md-5">
            {/* <button
              disabled={!costLot || !costTime || loading4}
              onClick={() => handleCostReport(selectedCostId)}
              className="add-button f3 w-100 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white"
            >
              {loading4 ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white", padding: 8 }}
                  ></span>
                </>
              ) : (
                <span style={{ top: -1.5, position: "relative" }}>
                  Get Cost Wise Report
                </span>
              )}
            </button> */}
            <SubmitButton
              disabled={!costLot || !costTime || loading4}
              onClick={() => handleCostReport(selectedCostId)}
              loading={loading4}
              title="Get Cost Wise Report"

            />
          </div>
          <span className="my-2 f4 fs-xs-17">CLIENT REPORT</span>
          <div className="announcement_date mb-3 col-md-5">
            <DateRange2
              selectedDate={clientDate}
              setSelectedDate={setClientDate}
            />
          </div>
          <div className=" my-3 col-md-5 ">
            <p className=" f3 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  primary1 mb-1">
              Client Mobile Number
            </p>
            <input
              className="input-box placholdercolorchanges2"
              name="userName"
              type="text"
              onChange={(e) => setMobile(e.target.value)}
              value={mobile}
              placeholder="Enter client mobile number"
              maxLength={10}
            />
            {errors.anountno && <p className="err">{errors.anountno}</p>}
          </div>{" "}
          <div className="my-3 pb-2 col-md-5">
            <div className="d-flex ac-js">
              <label
                className={`form-label m-0 f3 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  ${!clientDisable ? "gray" : "primary1"}`}
              >
                Lot Name
              </label>
            </div>
            <Select
              noOptionsMessage={() => ""}
              className="location-search"
              options={clientLotOptions}
              value={clientLot}
              onChange={(selected) => {
                setClientLot(selected);
                setClientTime(null);
                setClientSlotId(null);
              }}
              placeholder="Select Lot"
              styles={customStyles}
              isSearchable={false}
              isDisabled={!clientDate || !clientDisable}
            />
          </div>
          <div className=" my-3 pb-2 col-md-5">
            <div className="d-flex ac-js">
              <label
                className={`form-label m-0 f3 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  ${!clientDisable ? "gray" : "primary1"}`}
              >
                Time
              </label>
            </div>
            <Select
              noOptionsMessage={() => ""}
              className="location-search"
              onChange={(selected) => {
                setClientTime(selected);
                setClientSlotId(selected.id);
                setGameId(selected.game_id);
              }}
              options={clientTimeOptions}
              value={clientTime}
              placeholder="Select Time"
              styles={customStyles}
              isSearchable={false}
              isDisabled={!clientLot?.value || !clientDisable}
            />
          </div>
          <div style={{ textAlign: "center" }} className=" my-3 col-md-5">
            {/* <button
              disabled={!mobile || loading5 || loading6}
              onClick={() => handleClientReport(clientSLotId, false)}
              className="add-button f3 w-100 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white"
            >
              {loading5 ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white", padding: 8 }}
                  ></span>
                </>
              ) : (
                <span style={{ top: -1.5, position: "relative" }}>
                  Get Purchase Report
                </span>
              )}
            </button> */}
            <SubmitButton
              disabled={!mobile || loading5 || loading6}
              onClick={() => handleClientReport(clientSLotId, false)}
              loading={loading5}
              title="Get Purchase Report"

            />
          </div>
          <div style={{ textAlign: "center" }} className=" my-3 col-md-5">
            {/* <button
              disabled={!mobile || loading5 || loading6}
              onClick={() => handleClientReport(clientSLotId, true)}
              className="add-button f3 w-100 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white"
            >
              {loading6 ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white", padding: 8 }}
                  ></span>
                </>
              ) : (
                <span style={{ top: -1.5, position: "relative" }}>
                  Get Winning Report
                </span>
              )}
            </button> */}
            <SubmitButton
              disabled={!mobile || loading5 || loading6}
              onClick={() => handleClientReport(clientSLotId, true)}
              loading={loading6}
              title="Get Winning Report"

            />
          </div>
        </div>
      </CustomScroll>
    </div>
  );
};

export default Report;
